import { Box, Icon, ModalHeader, PrimaryButton, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Trans } from 'react-i18next'

import { ProposalPrefill } from '../../clients/api/clients/prefill'
import { Proposal } from '../../domain'
import { useErrorHandlingAsyncCallback } from '../../hooks/errors'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'
import { usePrincipal } from '../authentication'

export interface PrefillModalSuccessProps {
  tKey: TKeyBuilder
  proposalPrefill: ProposalPrefill
  onContinue: (proposal: Proposal) => void
}

export const PrefillModalSuccess: FunctionComponent<PrefillModalSuccessProps> = ({
  proposalPrefill,
  onContinue,
  tKey,
}) => {
  const { apiClient } = usePrincipal()
  const { t } = useWriskTranslation()

  const handleContinue = useErrorHandlingAsyncCallback(async () => {
    onContinue(
      await apiClient.createProposal({
        schemeCode: proposalPrefill.schemeCode,
        prefillResponseId: proposalPrefill.prefillResponseId,
        source: 'prefill',
      }),
    )
  })

  const header = (
    <Box
      display='flex'
      alignItems='center'
      width={1}
      columnGap={4}
      justifyContent='flex-start'
    >
      <Icon icon='tickFilled' size='large' />
      <Typo variant='heading' typoSize='xl'>
        {t(tKey('modals', 'success', 'header'))}
      </Typo>
    </Box>
  )

  const subheader = <Trans t={t} i18nKey={tKey('modals', 'success', 'subheader')} />

  return (
    <ModalHeader
      header={header}
      subheader={subheader}
      lowerContent={
        <PrimaryButton
          onClick={handleContinue.execute}
          loading={handleContinue.loading}
          mt={6}
        >
          {t(tKey('modals', 'success', 'actions', 'continue'))}
        </PrimaryButton>
      }
    />
  )
}
